const easingModuleUrl = "https://cdn.jsdelivr.net/npm/svelte@3.50.1/easing/index.mjs";
const transitionModuleUrl = "https://gist.githubusercontent.com/FaberVitale/ac6e1a97f1d577b977518216ce04b033/raw/clip-path-transitions.mjs";

export function renderCodeSnippet(inValues, outValues) {
  const inOptions = `{ duration: ${inValues.transitionDuration}, easing: ${inValues.transitionName} }`;
	const outOptions = `{ duration: ${outValues.transitionDuration}, easing: ${outValues.transitionName} }`;
	const indent = "          "
	
	const easingImports = Array.from(new Set([inValues.easingName, outValues.easingName])).join(", ");
	const transitionImports =  Array.from(new Set([inValues.transitionName, outValues.transitionName])).join(", ");

	const scriptTag = `<script>\n${indent}import { ${easingImports} } from "${easingModuleUrl}";\n${indent}import { ${transitionImports} } from "${transitionModuleUrl}";\n${indent.slice(2)}</script>`;
	
	return `${scriptTag}\n${indent.slice(2)}<div\n${indent}in:${inValues.transitionName}="{${inOptions}}"\n${indent}out:${outValues.transitionName}="{${outOptions}}"\n${indent.slice(2)}/>`;
}